import { triggerTracking } from '@zoopla/tracking';

export const trackAllListingsSelected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'select',
        eventLabel: 'quickfilter_all_listings'
    });
};

export const trackNewHomesSelected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'select',
        eventLabel: 'quickfilter_new_homes'
    });
};

export const trackChainFreeSelected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'select',
        eventLabel: 'quickfilter_chain_free'
    });
};

export const trackAddedLast7DaysSelected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'select',
        eventLabel: 'quickfilter_added_last_7_days'
    });
};

export const trackNewHomesDeselected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'deselect',
        eventLabel: 'quickfilter_new_homes'
    });
};

export const trackChainFreeDeselected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'deselect',
        eventLabel: 'quickfilter_chain_free'
    });
};

export const trackAddedLast7DaysDeselected = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'deselect',
        eventLabel: 'quickfilter_added_last_7_days'
    });
};
